export default __webpack_public_path__ + "static/logo_black-dcb35b9308133bdd9729db3a0198dcde.svg";